module.exports = __webpack_public_path__ + "static/img/number05.36572194.png";